import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-fluid assessment__container" }
const _hoisted_2 = {
  key: 1,
  class: "assessment__main"
}
const _hoisted_3 = { class: "assessment__level-slider-column" }
const _hoisted_4 = {
  key: 0,
  class: "assessment-level-slider-tip"
}
const _hoisted_5 = { class: "assessment-level-slider-tip__text" }
const _hoisted_6 = { class: "assessment__requirements-column" }
const _hoisted_7 = {
  key: 0,
  class: "assessment-skip-tip"
}
const _hoisted_8 = { class: "assessment-skip-tip__text" }
const _hoisted_9 = {
  key: 2,
  class: "assessment__footer"
}
const _hoisted_10 = { class: "assessment__footer-left" }
const _hoisted_11 = { class: "assessment__footer-copyright" }
const _hoisted_12 = { class: "assessment__footer-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_LevelSlider = _resolveComponent("LevelSlider")!
  const _component_LevelsDescription = _resolveComponent("LevelsDescription")!
  const _component_CategoryRequirements = _resolveComponent("CategoryRequirements")!
  const _component_PxIcon = _resolveComponent("PxIcon")!
  const _component_MobileFooterNav = _resolveComponent("MobileFooterNav")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'is-navigation-bar': _ctx.$screen.mdOnly }, "assessment"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showBackButton)
        ? (_openBlock(), _createBlock(_component_PxButton, _mergeProps({
            key: 0,
            class: "assessment__back-button"
          }, _ctx.$options.static.backButton, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
          }), null, 16))
        : _createCommentVNode("", true),
      (_ctx.currentCategory && _ctx.selectedStep)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_LevelSlider, {
                color: _ctx.currentCategory.color,
                levels: _ctx.currentCategory.categoryDetails.length,
                value: _ctx.selectedStep.level,
                height: "393px",
                onInput: _ctx.onLevelChange
              }, null, 8, ["color", "levels", "value", "onInput"]),
              (_ctx.selectedStep.level === 0 && _ctx.isFirstInteraction)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _cache[1] || (_cache[1] = _createElementVNode("img", {
                      alt: "Drag Tip Icon",
                      class: "assessment-level-slider-tip__icon",
                      src: "/img/arrow-tip.svg"
                    }, null, -1)),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("selfAssessment.assessment.dragTip")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_LevelsDescription, {
              "category-details": _ctx.currentCategory.categoryDetails,
              "current-level": _ctx.selectedStep.level,
              class: "assessment__levels-description",
              height: "342px"
            }, null, 8, ["category-details", "current-level"]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_CategoryRequirements, {
                category: _ctx.currentCategory,
                level: _ctx.selectedStep.level,
                class: "assessment__category-requirements"
              }, null, 8, ["category", "level"]),
              (_ctx.selectedStep.level === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_PxIcon, {
                      size: 16,
                      name: "information"
                    }),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("selfAssessment.assessment.noLevelTip")), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.$screen.mdOnly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("common.footer.copyright", {
                year: _ctx.currentYear,
              })), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.selectedCategory > 0)
                ? (_openBlock(), _createBlock(_component_PxButton, {
                    key: 0,
                    disabled: _ctx.loading,
                    type: "link",
                    onClick: _ctx.onGoPrev
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("selfAssessment.assessment.prevButton")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_PxButton, {
                loading: _ctx.loading,
                type: _ctx.nextButtonType,
                class: "assessment__next-btn",
                size: "medium",
                onClick: _ctx.onGoNext
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.nextButtonText) + " ", 1),
                  (!_ctx.isLastStep)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(_ctx.nextButtonIconClass)
                      }, null, 2))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["loading", "type", "onClick"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.$screen.mdOnly)
      ? (_openBlock(), _createBlock(_component_MobileFooterNav, {
          key: 0,
          loading: false,
          onNext: _ctx.onGoNext,
          onPrev: _ctx.onGoPrev
        }, null, 8, ["onNext", "onPrev"]))
      : _createCommentVNode("", true)
  ], 2))
}